import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import store from '@/core/redux/store';
import { routes } from '@/utils/routes/routes';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router';

const CustomerWelcome = () => {
  const user = store.getState().common.userDetails;
  const dispatch = useDispatch();

  console.log(user);
  return (
    <>
      <div className="row">
        <div className="col-md-12 mar-top-30">
          <div className="user-dashboard-tab__content tab-content">
            <div
              className="tab-pane fade show active mar-top-30"
              id="dashboard"
              role="tabpanel"
            >
              <h5>
                Hello <strong>{user?.name}</strong>
              </h5>
              <p>
                From your account dashboard you can easily check &amp; view your{' '}
                <Link
                  to={routes.customerDashboard}
                  onClick={() => dispatch(setActiveCustomerTab('orders'))}
                >
                  recent orders
                </Link>
                , manage your{' '}
                <Link
                  to={routes.customerDashboard}
                  onClick={() => dispatch(setActiveCustomerTab('address'))}
                >
                  shipping and billing addresses
                </Link>{' '}
                and
                <Link
                  to={routes.customerDashboard}
                  onClick={() =>
                    dispatch(setActiveCustomerTab('account-details'))
                  }
                >
                  {' '}
                  edit your password and account details
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerWelcome;
